import './Panel.css';

function Panel({ children, className, id }) {
  return (
    <div className={`panel ${className || ''}`} id={id}>
      {children}
    </div>
  );
}

export default Panel;
